import { LinkButton } from "@/ui/next/LinkButton";
import { useTranslation } from "next-i18next";

import { IconThemeTagLabelFilled } from "@/assets/icons/figma/IconThemeTagLabelFilled";
import { useSellRoute } from "@/features/us-market/hooks/useSellRoute";

/**
 * Header create ad button. Navigates the user to the create ad flow.
 */
export const HeaderCreateAd = () => {
  const { t } = useTranslation();
  const { href: sellHref } = useSellRoute("header");

  return (
    <>
      {/* Mobile */}
      <LinkButton
        type="button"
        size="small"
        className="md:hidden"
        href={sellHref}
      >
        {t("header:header-nav-sell")}
      </LinkButton>
      {/* Desktop */}
      <LinkButton
        type="button"
        size="large"
        leftIcon={<IconThemeTagLabelFilled className="size-6 shrink-0" />}
        className="hidden shrink-0 md:flex [&>span>span]:md:hidden [&>span>span]:lg:inline [&>span>svg]:hidden [&>span>svg]:md:block"
        href={sellHref}
      >
        {t("header:header-nav-sell")}
      </LinkButton>
    </>
  );
};
